import { render } from "./IncomeHeadCreate.vue?vue&type=template&id=42a60f22"
import script from "./IncomeHeadCreate.vue?vue&type=script&lang=js"
export * from "./IncomeHeadCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__